import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { Label } from 'web-ui-components/lib/atoms/forms';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { hideErrorMsg, initValidation, updateValidation } from '../../../../states/validation/actions';
import { getValidationRowState } from '../../../../states/validation/selectors';
import styles from '../BacsPaymentStyles';
import Amount from '../Form/Amount';

const mapState = (state, props) => ({
	validations: getValidationRowState(state, props.id),
});

const mapDispatch = (dispatch, props) => ({
	initValidation: () =>
		dispatch(
			initValidation({
				id: props.id,
			})
		),
	updateValidation: (key, isValid) =>
		dispatch(
			updateValidation({
				id: props.id,
				key,
				isValid,
			})
		),
	hideErrorMsg: (key) =>
		dispatch(
			hideErrorMsg({
				id: props.id,
				key,
			})
		),
});
class PaymentRow extends Component {
	componentWillMount() {
		this.props.initValidation();
	}

	render() {
		const {
			id,
			renderAccountField,
			showRemoveButton,
			handleRemovePayment,
			handleAmountBlur,
			content,
			showValidation,
			validations,
			hideErrorMsg,
			updateValidation,
			renderReferenceField,
			renderHMRCRefOrTransactionCodeField,
			templateMode,
			payment,
			biocatchIdentifier,
		} = this.props;

		const { amount } = payment;
		const { amountLabel } = content;

		return (
			<tr data-test-id="bacs-payment-row">
				<td>{renderAccountField(this.props)}</td>
				<td>
					<Label className={classnames(styles.main__inputLabel)}>{amountLabel}</Label>
					<Amount
						id={id}
						biocatchIdentifier={biocatchIdentifier}
						onBlur={handleAmountBlur}
						amount={amount}
						showValidation={showValidation}
						invalidMessage={content.amountInvalid}
						validations={validations}
						updateValidation={updateValidation}
						hideErrorMsg={hideErrorMsg}
						useValidation={!templateMode}
					/>
				</td>
				<td>{renderReferenceField(this.props)}</td>
				<td>{renderHMRCRefOrTransactionCodeField(this.props)}</td>
				<td className="delete-button-cell">
					{showRemoveButton && (
						<Button id={`field-delete-${id}`} onClick={handleRemovePayment} width="flush">
							<Icon iconType="TrashSmall" />
						</Button>
					)}
				</td>
			</tr>
		);
	}
}

PaymentRow.propTypes = {
	id: PropTypes.string.isRequired,
	payment: PropTypes.shape({
		id: PropTypes.string.isRequired,
	}),
	showRemoveButton: PropTypes.bool.isRequired,
	content: PropTypes.shape({}).isRequired,
	showValidation: PropTypes.bool.isRequired,
	initValidation: PropTypes.func.isRequired,
	updateValidation: PropTypes.func.isRequired,
	validations: PropTypes.shape({}).isRequired,
	hideErrorMsg: PropTypes.func.isRequired,
	handleRemovePayment: PropTypes.func.isRequired,
	handleAmountBlur: PropTypes.func.isRequired,
	renderReferenceField: PropTypes.func.isRequired,
	renderAccountField: PropTypes.func.isRequired,
	renderHMRCRefOrTransactionCodeField: PropTypes.func.isRequired,
	templateMode: PropTypes.bool,
};

export default connect(mapState, mapDispatch)(PaymentRow);
